import { useNavigate } from 'react-router-dom';

import { TableRow, TableCell } from '@occc/ui-design-system';
import { RetailerNetworkForMemberFragment } from '@occc/graphql';
import { routeCreator } from '@occc/feat-retailer-connect';

import { mapRoleTypeToLabel } from '../constants';

type RetailerNetworksForMemberRowProps = {
  retailerNetwork: RetailerNetworkForMemberFragment;
};

export const RetailerNetworksForMemberRow = ({
  retailerNetwork,
}: RetailerNetworksForMemberRowProps) => {
  const navigate = useNavigate();
  const onTableRowClick = () => navigate(routeCreator.overview(retailerNetwork.uuid));

  return (
    <TableRow onClick={onTableRowClick}>
      <TableCell>{retailerNetwork.name}</TableCell>
      <TableCell>{retailerNetwork.locationsCount}</TableCell>
      <TableCell>
        {retailerNetwork.roles
          ? retailerNetwork.roles.map((role) => mapRoleTypeToLabel[role]).join(', ')
          : ''}
      </TableCell>
    </TableRow>
  );
};
